import React from 'react'
import PropTypes from 'prop-types'
import {Box, Flex} from '@chakra-ui/react'
import {remCalc} from '../../../plugins/px-to-rem-babel-custom-plugin/utils/remCalc'
import HeadingComponentName from '../../components/heading-library'
import KeyFeatures from '../../../overrides/app/components/editorial-components/key-features'
import {
    keyFeaturesMockEditorial,
    keyFeaturesMockPdp,
} from '../../../overrides/app/components/editorial-components/key-features/mock'

function KeyFeaturesPage({pageStyle}) {
    return (
        <Box {...pageStyle}>
            <HeadingComponentName name="Key Features" />
            <Flex flexDir="column" padding={remCalc(40)} gap={remCalc(40)}>
                <KeyFeatures
                    title={keyFeaturesMockPdp.title}
                    description={keyFeaturesMockPdp.description}
                    cards={keyFeaturesMockPdp.cards}
                    isSlider
                />
                <KeyFeatures
                    title={keyFeaturesMockEditorial.title}
                    description={keyFeaturesMockEditorial.description}
                    cards={keyFeaturesMockEditorial.cards}
                />
            </Flex>
        </Box>
    )
}

KeyFeaturesPage.propTypes = {
    pageStyle: PropTypes.any,
}

export default KeyFeaturesPage
